import React from 'react';
import './ErrorBoundary.css';

// An uncaught render error in React unmounts the tree and leaves a blank white screen.
// On a kitchen display that is the worst possible failure: the staff get no orders and no
// indication that anything is wrong. Nobody is going to read a stack trace during service,
// so this shows a plain message and reloads itself.
const AUTO_RELOAD_SECONDS = 10;

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, secondsLeft: AUTO_RELOAD_SECONDS };
    this.reloadTimer = null;
    this.countdownTimer = null;
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Kitchen display crashed:', error, errorInfo?.componentStack);

    this.reloadTimer = setTimeout(() => window.location.reload(), AUTO_RELOAD_SECONDS * 1000);
    this.countdownTimer = setInterval(() => {
      this.setState((prev) => ({ secondsLeft: Math.max(0, prev.secondsLeft - 1) }));
    }, 1000);
  }

  componentWillUnmount() {
    if (this.reloadTimer) clearTimeout(this.reloadTimer);
    if (this.countdownTimer) clearInterval(this.countdownTimer);
  }

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <div className="error-boundary">
        <div className="error-boundary-card">
          <h1 className="error-boundary-title">Affichage interrompu</h1>
          <p className="error-boundary-text">
            Une erreur a interrompu l'affichage des commandes. L'écran se recharge
            automatiquement dans {this.state.secondsLeft}s.
          </p>
          <p className="error-boundary-hint">
            Les commandes ne sont pas perdues : elles sont conservées sur le serveur et
            réapparaîtront après le rechargement.
          </p>
          <button
            type="button"
            className="error-boundary-button"
            onClick={() => window.location.reload()}
          >
            Recharger maintenant
          </button>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
